import { useEffect, useState } from 'react';
import { GeometricLoader } from '../../../components/Layout/GeometricLoader';
import loginStyles from '../styles/login.module.scss'
import loginFormStyles from '../styles/loginForm.module.scss'
import uranusLogo from "../assets/icons/uranuslogo.svg";
import { useAuth } from '../hooks/useAuth';

interface ValidateSessionProps {
  message?: string;
}

export const ValidateSession = ({ message = "Validando sesión..." }: ValidateSessionProps) => {
  const { authenticate, isAuthenticated, token } = useAuth();
  const [showLoginButton, setShowLoginButton] = useState(false);
  const [debugInfo, setDebugInfo] = useState<string>('');

  useEffect(() => {
    console.log('🔐 ValidateSession - Auth state:', { isAuthenticated, hasToken: !!token });
    
    // Mostrar información de debug
    setDebugInfo(`Auth: ${isAuthenticated}, Token: ${!!token}`);
    
    // Si después de 5 segundos no hay autenticación, mostrar botón de login
    const timer = setTimeout(() => {
      if (!isAuthenticated && !token) {
        console.log('⏰ Timeout reached, showing login button');
        setShowLoginButton(true);
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, [isAuthenticated, token]);

  // Si debe mostrar el botón de login
  if (showLoginButton) {
    return (
      <div className={`${loginStyles.background_login}`} >
        <div className={`${loginFormStyles.main_login}`}>
          <div className={`${loginFormStyles.main_login__logo}`}>
            <img src={`${uranusLogo}`} alt="Uranus logo" />
          </div>
          <div className={`${loginFormStyles.main_login__title}`}>
            <h1>Sesión requerida</h1>
            <p style={{ fontSize: '14px', color: '#666', marginTop: '10px' }}>
              No se pudo validar la sesión automáticamente
            </p>
          </div>
          <button onClick={() => authenticate()} className={`${loginFormStyles.main_login__form__button}`}>
            <span className={`${loginFormStyles.main_login__button_text}`}>Iniciar sesión</span>
          </button>
          {process.env.NODE_ENV === 'development' && (
            <div style={{ marginTop: '20px', fontSize: '12px', color: '#999' }}>
              Debug: {debugInfo}
            </div>
          )}
        </div>
      </div>
    );
  }

  // Mostrar loader geométrico mientras valida
  return <GeometricLoader message={message} />;
}
